import {Injectable} from '@angular/core'
import {BehaviorSubject} from 'rxjs'
@Injectable({
  providedIn: 'root',
})
export class TransactionFilterService {
  constructor() {}
  activeTransactionFilters$ = new BehaviorSubject<any[]>([])
  activeTransactionFiltersAsObs$ = this.activeTransactionFilters$.asObservable()

  activeTransactionIndex$ = new BehaviorSubject<any>(null)
  activeTransactionIndexAsObs$ = this.activeTransactionIndex$.asObservable()

  setFilters(_: any[]) {}

  removeFilters(_: any[]) {}

  setActiveIndex(index: string) {
    this.activeTransactionIndex$.next(index)
  }
}
